export const ALLOWED_MARKDOWN_ELEMENTS = [
  'table',
  'thead',
  'tbody',
  'tr',
  'td',
  'th',
  'a',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'ul',
  'li',
  'ol',
  'br',
  'b',
  'em',
  'i',
  'strong'
]
